import React from "react";
import { FaPhone } from "react-icons/fa"; // Font Awesome phone icon

const FloatingCallButton = () => {
  return (
    <a href="tel:+1234567890" className="call-floating-btn">
      <FaPhone size={24} color="#fff" />
    </a>
  );
};

export default FloatingCallButton;
